import { render, staticRenderFns } from "./partyWork.vue?vue&type=template&id=a1623894&scoped=true"
import script from "./partyWork.vue?vue&type=script&lang=js"
export * from "./partyWork.vue?vue&type=script&lang=js"
import style0 from "./partyWork.vue?vue&type=style&index=0&id=a1623894&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1623894",
  null
  
)

export default component.exports